import { collection, doc, getDoc } from 'firebase/firestore';
import { firestore } from '../helpers/firebase';

const getDraft = async (userId) => {
  const year = new Date().getFullYear().toString();
  let returnDraft = null;
  try {
    returnDraft = await getDoc(doc(firestore, 'draft', year, 'draft', userId))
      .then(snapshot => (snapshot.exists() ? ({ ...snapshot.data(), found: true, error: false }) : ({ found: false, error: false })))
      .catch(error => ({ error: false, found: false }));
  } catch (error) {
    returnDraft = { error: error.message, found: false };
  }
  return returnDraft;
};

export default getDraft;
